import { Buffer } from 'buffer';
window.Buffer = Buffer;

import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MotionConfig } from 'framer-motion';
import { Toaster } from 'sonner';

import router from './router';
import './index.css';
import '@solana/wallet-adapter-react-ui/styles.css';
import { WalletProvider } from './wallet/WalletProvider';
import { useSettingsStore } from './state/settingsStore';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 10_000,
    },
  },
});

// Check if running on iOS to position toasts away from home indicator
const isIOS = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  return (
    /iphone|ipad|ipod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

const Root = () => {
  const motionReduced = useSettingsStore((state) => state.motionReduced);
  const toasterPosition = useMemo(() => (isIOS() ? 'top-right' : 'bottom-right'), []);

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <WalletProvider>
          <MotionConfig reducedMotion={motionReduced ? 'always' : 'never'}>
            <RouterProvider router={router} />
          </MotionConfig>
        </WalletProvider>
        <Toaster position={toasterPosition} expand theme="dark" />
      </QueryClientProvider>
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Root />);
